"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _C2MKKGTCcjs = require('../__chunks/C2MKKGTC.cjs');
require('../__chunks/I6T3D36K.cjs');
require('../__chunks/O7FALLU5.cjs');
require('../__chunks/MLKK6UGO.cjs');
require('../__chunks/WU47XUXM.cjs');
require('../__chunks/OJZKTJL7.cjs');
require('../__chunks/MMSR5JSJ.cjs');


var _EV33XSIBcjs = require('../__chunks/EV33XSIB.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');
require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/combobox/combobox-provider.tsx
var _jsxruntime = require('react/jsx-runtime');
function ComboboxProvider(props = {}) {
  const store = _C2MKKGTCcjs.useComboboxStore.call(void 0, props);
  return /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _EV33XSIBcjs.ComboboxContextProvider, { value: store, children: props.children });
}


exports.ComboboxProvider = ComboboxProvider;
